export const CONSTANTS = {
    IDENTIFICATION_TYPES_EN: [
        {value: "NRIC", label: "Identification Card No."},
        {value: "PASSPORT", label: "Passport No."},
        {value: "ARMY", label: "Army No."},
        {value: "BRN", label: "Business Registration No."},
    ],
    IDENTIFICATION_TYPES_BM: [
        {value: "NRIC", label: "No. Kad Pengenalan"},
        {value: "PASSPORT", label: "No. Passport"},
        {value: "ARMY", label: "No. Tentera"},
        {value: "BRN", label: "Business Registration No."},
    ],
    TIN_PREFIX: [
        {value: "IG", label: "IG"},
        {value: "C", label: "C"},
        {value: "CS", label: "CS"},
        {value: "D", label: "D"},
        {value: "E", label: "E"},
        {value: "F", label: "F"},
        {value: "FA", label: "FA"},
        {value: "PT", label: "PT"},
        {value: "TA", label: "TA"},
        {value: "TC", label: "TC"},
        {value: "TN", label: "TN"},
        {value: "TR", label: "TR"},
        {value: "TP", label: "TP"},
        {value: "J", label: "J"},
        {value: "LE", label: "LE"},
    ],
    STATE_CODES: [
        {
            "Code": "01",
            "State": "Johor"
        },
        {
            "Code": "02",
            "State": "Kedah"
        },
        {
            "Code": "03",
            "State": "Kelantan"
        },
        {
            "Code": "04",
            "State": "Melaka"
        },
        {
            "Code": "05",
            "State": "Negeri Sembilan"
        },
        {
            "Code": "06",
            "State": "Pahang"
        },
        {
            "Code": "07",
            "State": "Pulau Pinang"
        },
        {
            "Code": "08",
            "State": "Perak"
        },
        {
            "Code": "09",
            "State": "Perlis"
        },
        {
            "Code": "10",
            "State": "Selangor"
        },
        {
            "Code": "11",
            "State": "Terengganu"
        },
        {
            "Code": "12",
            "State": "Sabah"
        },
        {
            "Code": "13",
            "State": "Sarawak"
        },
        {
            "Code": "14",
            "State": "Wilayah Persekutuan Kuala Lumpur"
        },
        {
            "Code": "15",
            "State": "Wilayah Persekutuan Labuan"
        },
        {
            "Code": "16",
            "State": "Wilayah Persekutuan Putrajaya"
        },
        {
            "Code": "17",
            "State": "Not Applicable"
        }
    ]
}
